/**
 * Values must start with value to be picked up by the renderer
 */
export var OtherComponentType;
(function (OtherComponentType) {
    /**
     * Assembly 3D viewer. Requires 3D backend
     */
    OtherComponentType["Assembly3DViewer"] = "Other:Assembly3DViewer";
    OtherComponentType["CadClickViewer3D"] = "Other:CadClickViewer3D";
    OtherComponentType["CadClickCadBox"] = "Other:CadClickCadBox";
    OtherComponentType["AutoScrollBehavior"] = "Other:AutoScrollBehavior";
    OtherComponentType["UserDefinedFunctionButton"] = "Other:UserDefinedFunctionButton";
    OtherComponentType["Spacer"] = "Other:Spacer";
    OtherComponentType["Divider"] = "Other:Divider";
})(OtherComponentType || (OtherComponentType = {}));
//# sourceMappingURL=OtherComponentType.js.map